class UrlService {
    /* @ngInject */
    constructor(CONTEXT_PATH, $log) {
        this.$log = $log;
        this.contextPath = CONTEXT_PATH;
    }

    url(path, parameters) {
        var returnUrl = this.contextPath + path;

        if (parameters) {
            for (var key in parameters) {
                if (!parameters.hasOwnProperty(key)) {
                    continue;
                }

                var value = encodeURIComponent(parameters[key]);
                returnUrl = returnUrl.replace('{{' + key + '}}', value);
            }
        }

        return returnUrl;
    }
}

angular.module('egAngularUtils').service('egUrlService', UrlService);